const billsOfMaterialsTypes = {
  BILLS_OF_MATERIALS_TABLE_STATE_SET: 'BILLS_OF_MATERIALS/TABLE_STATE_SET',
  BILLS_OF_MATERIALS_TABLE_STATE_RESET: 'BILLS_OF_MATERIALS/TABLE_STATE_RESET',
};
export default billsOfMaterialsTypes;
